import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons'

import { useMessages2 } from '../hooks/useLanguage';
import { ButtonBar } from '../controls/buttons'
import { SidebarFixed, SidebarScrollable } from './sidebar';
import { blockSeparator } from '../controls/util-styles';
import { formatPrice } from './suggested-price';
import { PriceDetails } from '../app/types/api-types';
import { configuratorActions, savingConfigurationSelector } from '../app/configurator-slice';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { LoadingAnimation } from './loading-animation/loading-animation';
import { altSaveConfigurationSelector } from '../app/dev-slice';
import { catalogSelector } from '../app/configurator-selectors';
import { taxesinExcludedSelector } from '../app/main-slice';

import styles from './summary.module.css';

export const Summary = ({text, price, currency, modelName} : {
    text?: PriceDetails[]
    price?: number
    currency?: string
    modelName: string
}) => {

    // TODO some of this logic should go to a slice
    const { messages } = useMessages2();
    const dispatch = useAppDispatch();

    const isSaving = useAppSelector(savingConfigurationSelector);
    const showAltSaveConfiguration = useAppSelector(altSaveConfigurationSelector);
    const taxesinExcluded = useAppSelector(taxesinExcludedSelector);
    const catalog = useAppSelector(catalogSelector);

    const onHandleSaveAlt = async () => {
        dispatch(configuratorActions.saveConfiguration({ altMethod: false }))
    }

    const onHandleSave = async () => {
        dispatch(configuratorActions.saveConfiguration({ altMethod: true }))
    }
  
    const elementList = () => (
        <div className={styles.contentContainer}>
            {text?.map((element, index) => (
                <div key={`description-${index}`} className={styles.elementItem}>
                    <span className={styles.elementTitle}>{element?.title}</span>
                    <span>{element?.description.charAt(0).toUpperCase() + element?.description.slice(1)}</span>
                    <span className={styles.elementCode}>{`${messages?.summary_external_code} ${element.externalcodes}`}</span>
                </div>
            ))}
        </div>
    )

    return <>
        <SidebarFixed>
            <div className={styles.model}>
                <h3>{messages?.overlay_model_prefix.split(":")[0]}</h3>
                <h4>{modelName}</h4>
            </div>
        </SidebarFixed>

        <SidebarScrollable>
            <div className={styles.elements}>
                <h3 className={styles.elementTitle}>{messages?.sofa_summary_elementen.split(":")[0]}</h3>
                {
                    text && text.length > 0 ? elementList()
                                        :
                                        <LoadingAnimation use="summary"/>
                }
            </div>
        </SidebarScrollable>
                     
        <SidebarFixed>
            { price ? <div className={styles.priceArea}>
                        <p className={styles.priceRow}>
                            <div className={styles.priceText}>{ messages?.Suggested_price_this_configuration }
                             {taxesinExcluded === 'e' && <span className={styles.taxesNote}><br/>{messages?.tax_excluded}</span>}
                            </div>
                            <div className={styles.pricePrice}>{ formatPrice(price) }&nbsp;{ currency ? currency.toUpperCase() : '' }</div>
                        </p>

            
                      </div> 
                      :
                      null }
            <ButtonBar className={blockSeparator} fill={true}>
                <button className={styles.buttons} type="button" disabled={isSaving || !text || text.length === 0 || !text.some(item => item.externalcodes)} onClick={onHandleSave}>
                    <div className={styles.summaryLabel}>{ messages?.final_pdf_button }</div> 
                    <FontAwesomeIcon icon={faFilePdf} className={styles.pdfIcon}/>
                </button>
                { showAltSaveConfiguration ? 
                    <button className={styles.buttons} type="button" onClick={onHandleSaveAlt} style={{flex:0}}>ALT</button>
                    :
                    null
                }
            </ButtonBar>
        </SidebarFixed>
    </>
}

